import { pixelRatio2d } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { Vector2 } from 'three';

export function formatLinearDimensionPoint(points: IPoint2d[]) {
  const [startPoint, endPoint, dirPoint] = points;
  if (!dirPoint) return { startPoint, endPoint, offset: 0 };

  const startVec = new Vector2(startPoint.x / pixelRatio2d, startPoint.y / pixelRatio2d);
  const endVec = new Vector2(endPoint.x / pixelRatio2d, endPoint.y / pixelRatio2d);
  const edgeVec = new Vector2().subVectors(endVec, startVec);
  const outwardNormal = new Vector2(edgeVec.y, -edgeVec.x).normalize();
  const mouseVec = new Vector2().subVectors(
    new Vector2(dirPoint.x / pixelRatio2d, dirPoint.y / pixelRatio2d),
    startVec
  );
  const offset = mouseVec.dot(outwardNormal); // 沿法线方向的位移量

  const offsetVec = new Vector2(outwardNormal.x * offset, outwardNormal.y * offset);
  startVec.add(offsetVec);
  endVec.add(offsetVec);

  return {
    startPoint,
    endPoint,
    offset: -offset * pixelRatio2d
  };
}
